import ScrollMagic from 'scrollmagic';

export default () => {

	return {

		mounted() {

			const controller = new ScrollMagic.Controller();
			const section1 = document.querySelector('#section-1');
			const section2 = document.querySelector('#section-2');
			const section3 = document.querySelector('#section-3');
			const section4 = document.querySelector('#section-4');
			const section5 = document.querySelector('#section-5');
			const section6 = document.querySelector('#section-6');
			const section7 = document.querySelector('#section-7');
			const section8 = document.querySelector('#section-8');
			const section9 = document.querySelector('#section-9');
			const section10 = document.querySelector('#section-10');

			if (section1 != null) {
				var scene1 = new ScrollMagic.Scene({ triggerElement: '#trigger-1', duration: '100%' });
				scene1.setClassToggle(section1, 'is-on-screen').addTo(controller);
			}

			if (section2 != null) {
				var scene2 = new ScrollMagic.Scene({ triggerElement: '#trigger-2', duration: '100%' });
				scene2.setClassToggle(section2, 'is-on-screen').addTo(controller);
			}

			if (section3 != null) {
				var scene3 = new ScrollMagic.Scene({ triggerElement: '#trigger-3', duration: '100%' });
				scene3.setClassToggle(section3, 'is-on-screen').addTo(controller);
			}

			if (section4 != null) {
				var scene4 = new ScrollMagic.Scene({ triggerElement: '#trigger-4', duration: '100%' });
				scene4.setClassToggle(section4, 'is-on-screen').addTo(controller);
			}

			if (section5 != null) {
				var scene5 = new ScrollMagic.Scene({ triggerElement: '#trigger-5', duration: '100%' });
				scene5.setClassToggle(section5, 'is-on-screen').addTo(controller);
			}

			if (section6 != null) {
				var scene6 = new ScrollMagic.Scene({ triggerElement: '#trigger-6', duration: '100%' });
				scene6.setClassToggle(section6, 'is-on-screen').addTo(controller);
			}

			if (section7 != null) {
				var scene7 = new ScrollMagic.Scene({ triggerElement: '#trigger-7', duration: '100%' });
				scene7.setClassToggle(section7, 'is-on-screen').addTo(controller);
			}

			if (section8 != null) {
				var scene8 = new ScrollMagic.Scene({ triggerElement: '#trigger-8', duration: '100%' });
				scene8.setClassToggle(section8, 'is-on-screen').addTo(controller);
			}

			if (section9 != null) {
				var scene9 = new ScrollMagic.Scene({ triggerElement: '#trigger-9', duration: '100%' });
				scene9.setClassToggle(section9, 'is-on-screen').addTo(controller);
			}

			if (section10 != null) {
				var scene10 = new ScrollMagic.Scene({ triggerElement: '#trigger-10', duration: '100%' });
				scene10.setClassToggle(section10, 'is-on-screen').addTo(controller);
			}

		}

	}

}